import styled from '@emotion/styled';

const TabsWrapper = styled('header')({
  marginBottom: 12,
  display: 'flex',
});

export default TabsWrapper;
